import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { api } from '../helpers/utils';

const BookingWebView = () => {
    const [finalAmount, setFinalAmount] = useState(null);
    const [bookingData, setBookingData] = useState(null);
    const [userAmount, setUserAmount] = useState('');
    const [slotStartTime, setSlotStartTime] = useState('11:51');
    const [slotEndTime, setSlotEndTime] = useState('11:51');

    const query = new URLSearchParams(window.location.search);

    const [bookedUsers, setBookedUsers] = useState([])
    const venueId = query.get('venueId');
    const userId = query.get('userId');
    const vibeId = query.get('vibeId');

    useEffect(() => {
        const fetchBookingDetails = async () => {
            try {
                const res = await api.post('/get-vibe-booking-details', {
                    venueId,
                    userId,
                    latLong: {
                        latitude: query.get('lat'),
                        longitude: query.get('long'),
                    },
                });

                if (res.data.status === 100) {
                    const venue = res.data.venueDetails;
                    setBookingData(venue);
                    setBookedUsers(res.data.bookedUserDetails)

                    if (venue.isPreBook) {
                        const actualPrice = venue.actualPrice || 0;
                        const offer = venue.offer || 0;
                        const platformFee = venue.platfromFee || 0;
                        const discount = (offer / 100) * actualPrice;
                        const total = actualPrice - discount + platformFee;
                        setFinalAmount(total.toFixed(2));
                    }
                }
            } catch (e) {
                console.error('Error fetching booking data', e);
            }
        };

        if (venueId && userId) fetchBookingDetails();
    }, [venueId]);

    //   const getUserVibeDetails = async () => {


    // useEffect(()=>{
    //     getUserVibeDetails()
    // },[vibeId])




    const calculateDynamicTotal = () => {
        if (!userAmount || isNaN(userAmount)) return '0.00';
        const base = parseFloat(userAmount);
        const discount = ((bookingData.offer || 0) / 100) * base;
        const total = base - discount + (bookingData.platfromFee || 0);
        return total.toFixed(2);
    };

    if (!bookingData) return <div style={styles.loading}>Loading...</div>;
    const isPreBook = bookingData.isPreBook;

    return (
        <div style={styles.container}>
            {/* Call to Book (Top) */}
            {isPreBook && !bookingData.isEvent && (
                <button
                    onClick={() => window.location.href = `tel:${bookingData.mobile}`}
                    style={styles.callButton}
                >
                    📞 Call to book slot
                </button>
            )}

            {/* Slot Time Pickers */}
            {isPreBook && !bookingData.isEvent && (
                <>
                    <p style={styles.subheading}>Select Slot Start Time</p>
                    <input
                        type="time"
                        value={slotStartTime}
                        onChange={(e) => setSlotStartTime(e.target.value)}
                        style={styles.input}
                    />

                    <p style={styles.subheading}>Select Slot End Time</p>
                    <input
                        type="time"
                        value={slotEndTime}
                        onChange={(e) => setSlotEndTime(e.target.value)}
                        style={styles.input}
                    />
                </>
            )}

            {/* If not pre-book, show amount input */}
            {!isPreBook && (
                <>
                    <p style={styles.subheading}>Enter Amount to Pay</p>
                    <input
                        type="number"
                        style={styles.input}
                        placeholder="₹ Amount"
                        value={userAmount}
                        onChange={(e) => setUserAmount(e.target.value)}
                    />
                </>
            )}

            {/* Payment Summary */}
            <div style={styles.summaryBox}>
                <div style={styles.row}>
                    <span>Actual Price</span>
                    <span>₹ {isPreBook ? bookingData.actualPrice : userAmount || '0.00'}</span>
                </div>
                <div style={styles.row}>
                    <span>Discount</span>
                    <span style={{ color: '#bb86fc' }}>{bookingData.offer || 0}%</span>
                </div>
                <div style={styles.row}>
                    <span>Platform Fee</span>
                    <span>₹ {bookingData.platfromFee}</span>
                </div>
                <hr />
                <div style={styles.row}>
                    <strong>Total to Pay</strong>
                    <strong>
                        ₹ {isPreBook ? finalAmount : calculateDynamicTotal()}
                    </strong>
                </div>
            </div>

            <p style={styles.note}>* This booking is non-refundable.</p>

            <button
                style={styles.payButton}
                onClick={() => {
                    window.ReactNativeWebView?.postMessage(
                        JSON.stringify({
                            finalAmount: isPreBook ? finalAmount : calculateDynamicTotal(),
                            slotStartTime,
                            slotEndTime,
                        })
                    );
                }}
            >
                Pay Now
            </button>

            {bookedUsers.length > 0 && (
                <div style={{ marginTop: 20 }}>
                    <h3 style={{ color: '#fff', marginBottom: 10 }}>People who booked:</h3>
                    <ul style={{ padding: 0, listStyle: 'none' }}>
                        {bookedUsers.map(user => (
                            <li
                                key={user._id}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 12,
                                    marginBottom: 10,
                                }}
                            >
                                <img
                                    src={user.userProfilePic || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(user.userName || 'User')}
                                    alt="avatar"
                                    style={{
                                        width: 40,
                                        height: 40,
                                        borderRadius: '50%',
                                        objectFit: 'cover',
                                        border: '1px solid #444',
                                    }}
                                />
                                <span style={{ color: '#ccc', fontSize: 15 }}>
                                    {user.userName || 'Unnamed User'}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

const styles = {
    container: {
        fontFamily: 'Arial, sans-serif',
        color: '#fff',
        minHeight: '100vh',
        width: '100%',
        // padding: 20,
        // backgroundColor: '#121212',
    },
    loading: {
        color: '#fff',
        textAlign: 'center',
        marginTop: 100,
    },
    subheading: {
        marginTop: 20,
        fontSize: 16,
        fontWeight: 'bold',
    },
    input: {
        padding: 10,
        borderRadius: 8,
        border: '1px solid #555',
        backgroundColor: '#1a1a1a',
        color: 'white',
        width: '95%',
        fontSize: 16,
        marginTop: 8,
    },
    summaryBox: {
        backgroundColor: '#1e1e1e',
        borderRadius: 12,
        padding: 16,
        marginTop: 30,
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 10,
        fontSize: 15,
    },
    note: {
        fontSize: 12,
        color: '#f39c12',
        marginTop: 16,
        textAlign: 'center',
    },
    payButton: {
        marginTop: 24,
        backgroundColor: '#00AEEF',
        padding: '14px 24px',
        border: 'none',
        borderRadius: 8,
        color: 'white',
        fontSize: 16,
        fontWeight: 'bold',
        cursor: 'pointer',
        width: '100%',
    },
    callButton: {
        marginBottom: 16,
        padding: '12px 16px',
        backgroundColor: '#fff',
        color: '#000',
        borderRadius: 8,
        border: 'none',
        cursor: 'pointer',
        fontWeight: 'bold',
        width: '100%',
        fontSize: 16
    }
};

export default BookingWebView;
